
/*
*edit front
*/



$(document).on('click','.edit_front_tab',function(e) {
  e.preventDefault();
   $('.front_tab').addClass('active');
   $('.back_tab').removeClass('hide');
   $('.front_tab').removeClass('hide');
   $('.back_tab').removeClass('active');
   $('.edit_front_tab').addClass('hide');
   $('.edit_back_tab').addClass('hide');
 setTimeout(() => {
  console.log("Delayed for 1 second.");
   $('.front_tab').addClass('active');
}, "1000");

  
  /* if text upload section active*/
 if ($(".inner_text_design_content.active")[0]){
   $('.inner_text_design_content').removeClass('active');
    $('.front_text_preview').removeClass('active');
      $('.front_text_preview').addClass('hide');
   $('.back_text_preview').removeClass('active');
   $('.back_text_preview').addClass('hide');

    $('.left_image_customize').removeClass('both_active');
     $('.back_image').removeClass('active');
      $(".color_customize_variants").css('display','block');
      $('.color_customize_variants').removeAttr('style');
      $('.addtocart_box').addClass('hide');
      $('.upload_nav_design .clear_btn').removeClass('hide');
     $('.upload_nav_design .preview_btn').removeClass('hide');
    $('.customize-selection').removeClass('hide');
     
}
  



//   /* logo box*/
 if($(".inner_logo_designs_content.active")[0]){
   $(".color_customize_variants").css('display','block');
   $('.left_image_customize').removeClass('both_active');
   $('.back_image').removeClass('active');
   $('.gallery_nav_design .clear_btn').removeClass('hide');
    $('.gallery_nav_design .preview_btn').removeClass('hide');
   $('.gallery_nav_design .addtocart_box').addClass('hide');
  
   $('.addtocart_box').addClass('hide');
   $('.inner_logo_designs_content').removeClass('active')
   $('.animal').addClass('hide');
   $('.family').addClass('hide');
   $('.sports').addClass('hide');
    $('.line').addClass('hide');
    $(".travel").addClass("hide");
      $(".nature").addClass("hide");
         $(".weekend").addClass("hide");

    $('.back_logo.back_btn').removeClass('hide');
    $('.back_animal.back_inner').addClass('hide'); 
    $('.back_family.back_inner').addClass('hide'); 
   $('.back_sports.back_inner').addClass('hide'); 
    $('.back_lineart.back_inner').addClass('hide'); 
    $(".back_nature.back_inner").addClass("hide");
    $(".back_weekend.back_inner").addClass("hide");
   $(".back_nature_travel.back_inner").addClass("hide");
      $('.back_dog').addClass('hide'); 
   $('.back_cats').addClass('hide'); 
   $('.dogs').addClass('hide'); 
    $('.cats').addClass('hide'); 
   $(".inner_gallerry_wraper.pets_gallery").removeClass("hide");
   
}

/*
*fathers days outer
 */
 if($(".outerinner_logo_designs_content.active")[0]){
$('.left_image_customize').removeClass('both_active');
$('.back_image').removeClass('active');
$('.outergallery_nav_design .clear_btn').removeClass('hide');
$('.outergallery_nav_design .preview_btn').removeClass('hide');
$('.outergallery_nav_design .addtocart_box').addClass('hide');
$('.back_outer.back_btn').removeClass('hide');
 $('.outerinner_logo_designs_content').removeClass('active');
 }
  
if($(".selected_design_box.active")[0]){
   $(".selected_design_box.active .inner_selected_design").css('display','block');
 $(".color_customize_variants").css('display','block');
   $('.back_image').removeClass('active');
  $('.left_image_customize').removeClass('both_active');
  $('.addtocart_box').addClass('hide');
$('#inverseCheckbox').css('display','inline');
  $('.s1').css('display','inline');
  $('#backinverseCheckbox').css('display','none');
  $('.s2').css('display','none');
  
}


 $('.customize-selection').removeClass('hide');
      $('.selected_design_box').removeClass('active');
     $('.inner_selected_design.design_uplod.customization-section').removeClass('active');
    $('.inner_selected_design.design_uplod.customization-section').removeAttr('style');

    // var backhtml = $('.back_image .cstm_textup').html();
 var fronthtml = $('.front_image .cstm_textup').html();
if(fronthtml != '' || fronthtml !=' ')
{
  $('.front_image .text_uploaded').removeClass('hide');
  $('.front_image .text_uploaded').addClass('active');
}


});


/*edit back tab*/
$(document).on('click','.edit_back_tab',function(e) {
  e.preventDefault();
   $('.front_tab').removeClass('active');
   $('.back_tab').removeClass('hide');
   $('.front_tab').removeClass('hide');
   $('.back_tab').addClass('active');
   $('.edit_front_tab').addClass('hide');
   $('.edit_back_tab').addClass('hide');
 setTimeout(() => {
  console.log("Delayed for 1 second.");
   $('.back_tab').addClass('active');
}, "1000");

  
  /* if text upload section active*/
 if ($(".inner_text_design_content.active")[0]){
   $('.inner_text_design_content').removeClass('active');
    $('.front_text_preview').removeClass('active');
      $('.front_text_preview').addClass('hide');
   $('.back_text_preview').removeClass('active');
   $('.back_text_preview').addClass('hide');

    $('.left_image_customize').removeClass('both_active');
     $('.front_image').removeClass('active');
      $(".color_customize_variants").css('display','block');
      $('.color_customize_variants').removeAttr('style');
      $('.addtocart_box').addClass('hide');
      $('.upload_nav_design .clear_btn').removeClass('hide');
     $('.upload_nav_design .preview_btn').removeClass('hide');
    $('.customize-selection').removeClass('hide');
     
}
  



//   /* logo box*/
 if($(".inner_logo_designs_content.active")[0]){
   $(".color_customize_variants").css('display','block');
   $('.left_image_customize').removeClass('both_active');
   $('.front_image').removeClass('active');
   $('.gallery_nav_design .clear_btn').removeClass('hide');
    $('.gallery_nav_design .preview_btn').removeClass('hide');
   $('.gallery_nav_design .addtocart_box').addClass('hide');
   $('.back_animal.back_inner').addClass('hide'); 
    $('.back_family.back_inner').addClass('hide'); 
 
      $('.inner_logo_designs_content').removeClass('active');
   
    $('.back_logo.back_btn').removeClass('hide');
    $('.animal').addClass('hide');
    $('.family').addClass('hide');
 $(".travel").addClass("hide");
  $(".nature").addClass("hide");
    $(".weekend").addClass("hide");
   $('.sports').addClass('hide');
    $('.line').addClass('hide');
  
    $('.back_animal.back_inner').addClass('hide'); 
     $('.back_family.back_inner').addClass('hide');
   $('.back_sports.back_inner').addClass('hide'); 
    $('.back_lineart.back_inner').addClass('hide'); 
    $('.back_nature_travel.back_inner').addClass('hide'); 
    $('.back_nature.back_inner').addClass('hide'); 
       $('.back_weekend.back_inner').addClass('hide'); 

   $('.back_dog').addClass('hide'); 
   $('.back_cats').addClass('hide'); 
   $('.dogs').addClass('hide'); 
    $('.cats').addClass('hide'); 
   $(".inner_gallerry_wraper.pets_gallery").removeClass("hide");
   
   
}

/*
*fathers days outer
 */
 if($(".outerinner_logo_designs_content.active")[0]){
 
$('.left_image_customize').removeClass('both_active');
$('.front_image').removeClass('active');
$('.outergallery_nav_design .clear_btn').removeClass('hide');
$('.outergallery_nav_design .preview_btn').removeClass('hide');
$('.outergallery_nav_design .addtocart_box').addClass('hide');
$('.back_outer.back_btn').removeClass('hide');
 $('.outerinner_logo_designs_content').removeClass('active');
 }
  


if($(".selected_design_box.active")[0]){
   $(".selected_design_box.active .inner_selected_design").css('display','block');
 $(".color_customize_variants").css('display','block');
   $('.front_image').removeClass('active');
  
  $('.left_image_customize').removeClass('both_active');
  $('.addtocart_box').addClass('hide');
  $('#inverseCheckbox').css('display','none');
  $('.s1').css('display','none');
  $('#backinverseCheckbox').css('display','inline');
  $('.s2').css('display','inline');
}


 $('.customize-selection').removeClass('hide');
      $('.selected_design_box').removeClass('active');
     $('.inner_selected_design.design_uplod.customization-section').removeClass('active');
    $('.inner_selected_design.design_uplod.customization-section').removeAttr('style');

     var backhtml = $('.back_image .cstm_textup').html();
 // var fronthtml = $('.front_image .cstm_textup').html();
if(backhtml != '' || backhtml !=' ')
{
  $('.back_image .text_uploaded').removeClass('hide');
  $('.back_image .text_uploaded').addClass('active');
}


});



